export default "__VITE_ASSET__q8n7SwP1__ 300w";